export const desktopWidth = 1110;
export const desktopNormalWidth = 1320;
export const tabWidth =  768;
export const mediumPhoneWidth = 355;

export const axiosConfig = { 'headers': { 'Cache-Control': 'no-cache', 'Authorization': 'Bearer ' + localStorage.getItem('fitbase_token') } };
export const POSITION_WINDOW = 'window'
export const POSITION_CALENDAR = 'calendar'
